import React from 'react';
import ReactDOM from 'react-dom/client';
import {Complete, TYPE} from "../src/components/Complete";

export const render = (shop, roots, onDesignate, locationId) => {
    roots.forEach(el => {
        const root = ReactDOM.createRoot(el);
        const type = el.dataset.display || TYPE.LIST
        let searchParams = {}

        let paramOnDesignate = (id, params = {}) => {
            if (el.dataset.source) {
                params.designated_by = el.dataset.source
            } else {
                params.designated_by = 'locator' // default
            }
            return onDesignate(id, params)
        }

        const params = {
            shop,
            designated: locationId,
            type,
            onDesignate: paramOnDesignate,
            searchParams,
            renderCallback: (el) => {
                el.dispatchEvent(new Event('ready', {
                    bubbles: true,
                    cancelable: true,
                }))
                el.dispatchEvent(new Event('locator.ready', {
                    bubbles: true,
                    cancelable: true,
                }))
            }
        }

        root.render(<Complete {...params} />)

        el.bindForm = function($form) {
            let form = {
                location: $form.find('input[name="location"]'),
                term: $form.find('input[name="term"]'),
                tags: $form.find('input[name="tags[]"]'),
            }

            $form.submit(function() {
                let params = {
                    location: form.location.val(),
                    term: form.term.val(),
                    tags: form.tags.filter(':checked').map(function() {
                        return this.value
                    }).get(),
                }

                el.search(params)
                return false
            })

            let params = el.searchParams()
            let tags = params.tags || []
            form.location.val(params.location)
            form.term.val(params.term)
            form.tags.each(function() {
                $(this).prop('checked', tags.includes(this.value)) // try avoiding $ here
            })
        }
    })
}
